// Validadores por etapa do formulário de inscrição.
// Cada função recebe (form, isCasado) e retorna mensagem de erro string OU null.

const requiredString = (v) => typeof v === "string" && v.trim().length > 0;

const validateResponsavel = (form) => {
  const required = ["nome_completo", "cpf", "data_nascimento", "sexo", "estado_civil", "telefone", "email"];
  if (!required.every((k) => requiredString(form[k]))) return "Preencha os campos obrigatórios (incluindo e-mail)";
  const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim());
  if (!emailOk) return "Informe um e-mail válido";
  return null;
};

const validateConjuge = (form, isCasado) => {
  if (!isCasado) return null;
  return requiredString(form.conjuge_nome) && requiredString(form.conjuge_cpf) ? null : "Informe dados do cônjuge";
};

const validateEndereco = (form) => {
  const required = ["cep", "rua", "numero", "bairro"];
  return required.every((k) => requiredString(form[k])) ? null : "Endereço incompleto";
};

const validateDeclaracao = (form) => (form.declaracao_veracidade ? null : "Aceite a declaração de veracidade");

const validators = {
  0: validateResponsavel,
  1: validateConjuge,
  3: validateEndereco,
  9: validateDeclaracao,
};

export function validateStep(step, form, isCasado) {
  const fn = validators[step];
  return fn ? fn(form, isCasado) : null;
}
